import Link from 'next/link'
import { Button } from '@ui/base/button'
import { Card } from '@ui/base/card'
import { LandingCardRow, LandingCardStripe, LandingHero, landingType } from '@ui/landing'

import { requestWizardPath } from '../config'

/**
 * Бланк-пример рядом с заголовком: показывает, из чего состоит заявка и чем она заканчивается.
 * Числа в нём выдуманы, поэтому блок подписан как пример, а цен в нём нет — иначе выдуманная
 * цифра читалась бы как обещание сервиса. На узком экране бланк скрыт: те же числа идут ниже.
 */
const RequestBlank = () => (
  <Card variant="raised" className="hidden overflow-hidden lg:block">
    <LandingCardStripe />
    <div className="grid gap-2 px-6 py-5">
      <span className={`${landingType.eyebrow} ${landingType.mutedText}`}>Пример заявки</span>
      <span className="text-[19px] leading-[1.3] font-medium">Приёмка и упаковка футболок</span>
    </div>

    <dl className="grid gap-3 border-t px-6 py-5">
      {[
        ['Забрать', 'Москва'],
        ['Отгрузить', 'Коледино, WB'],
        ['Объём', '500 ед.'],
      ].map(([label, value]) => (
        <div key={label} className="flex items-baseline justify-between gap-4">
          <dt className={`${landingType.bodyText} ${landingType.mutedText}`}>{label}</dt>
          <dd className={`${landingType.bodyText} font-medium`}>{value}</dd>
        </div>
      ))}
    </dl>

    <LandingCardRow label="Стоимость заявки" note="ответы фулфилментов тоже бесплатны">
      <span className={`${landingType.figure} text-primary`}>0 ₽</span>
    </LandingCardRow>

    <div className="grid gap-4 border-t px-6 py-5">
      <Button render={<Link href={requestWizardPath} />}>Оставить заявку</Button>
    </div>
  </Card>
)

/** Три главных условия сразу под вводным абзацем: их читают вместо всего остального текста. */
const facts = [
  { value: '0 ₽', note: 'заявка и ответы' },
  { value: 'Без входа', note: 'учётная запись — на последнем шаге' },
  { value: 'Без обзвона', note: 'фулфилменты отвечают сами' },
]

/** Первый экран: обещание, три условия и бланк-пример заявки. */
export const RequestHero = () => (
  <LandingHero
    badge="Продавцам маркетплейсов"
    title={
      // Вторая часть заголовка на широком экране начинается с новой строки: иначе синий текст
      // стартует с середины строки и заголовок читается рвано.
      <>
        Опишите задачу один раз — <span className="text-primary lg:block">цены посчитают за вас</span>
      </>
    }
    leadText="Заявка уходит всем фулфилментам, которые работают по вашей схеме, возят на ваши площадки и подходят по географии. Каждый считает по вашим данным и присылает своё предложение — вы сравниваете их в одном месте и пишете тому, кто подошёл."
    extra={
      <dl className="mt-7 grid gap-4 sm:grid-cols-3 sm:gap-8">
        {facts.map((fact) => (
          <div key={fact.value} className="grid gap-0.5">
            <dt className="text-[20px] leading-[1.3] font-semibold tracking-[-0.012em]">{fact.value}</dt>
            <dd className={`${landingType.noteText} ${landingType.mutedText}`}>{fact.note}</dd>
          </div>
        ))}
      </dl>
    }
    primaryAction={{ href: requestWizardPath, label: 'Оставить заявку бесплатно' }}
    secondaryAction={{ href: '/fulfillment', label: 'Посмотреть каталог' }}
    aside={<RequestBlank />}
  />
)
